"use strict";

var KTHeader = function(elementId, options) {
    // Main object
    var the = this;
    var init = false;

    // Get element object
    var element = KTUtil.get(elementId);
    var body = KTUtil.get('body');

    if (element === undefined) {
        return;
    }

    // Default options
    var defaultOptions = {
        classic: false,
        offset: {
            mobile: 150,
            desktop: 200
        },
        minimize: {
            mobile: false,
            desktop: false
        }
    };

    var readCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    ////////////////////////////
    // ** Location Notifications ** //
    ////////////////////////////

    $(document).on('click', '.dropdown-notifications', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '.notification-url', function (e) {
        
        var notiID = $(this).attr("data-notid");

        $.ajax({
            url: 'https://'+document.location.hostname+'/api/v2/Notifications/MarkNotificationAsReadForLocation.php',
            type: 'post',
            dataType: 'json',
            data: {notiID: notiID},
            success: function(result) {
            },
            error: function(result) {
            }
        });

    });

    $(document).on('click', '.notification-clear', function (e) {

        $(this).closest(".notification-item").fadeOut(200);
        var notiID = $(this).attr("data-notid");

        $.ajax({
            url: 'https://'+document.location.hostname+'/api/v2/Notifications/MarkNotificationAsReadForLocation.php',
            type: 'post',
            dataType: 'json',
            data: {notiID: notiID},
            success: function(result) {
                loadLocationNotifications();
            },
            error: function(result) {
            }
        });

    });

    $(document).on('click', '#clear-all-notifications', function (e) {

        // Only mark the notifications currently displayed as read — unread notifications
        // beyond the panel's page stay unread and keep counting in the badge
        var notiIDs = $(".notifications-holder .notification-url").map(function() {
            return $(this).attr("data-notid");
        }).get();

        if (notiIDs.length === 0) {
            return;
        }

        $(".notification-item").fadeOut(200);

        $.ajax({
            url: 'https://'+document.location.hostname+'/api/v2/Notifications/ClearAllNotificaitonsForLocation.php',
            type: 'post',
            dataType: 'json',
            data: {notiIDs: notiIDs},
            success: function(result) {
                loadLocationNotifications();
            },
            error: function(result) {
                loadLocationNotifications();
            }
        });

    });

    var updateUnreadBadge = function(countUnread) {
        var badge = $(".header-unread-notifications");
        if (countUnread > 0) {
            badge.text(countUnread > 99 ? '99+' : countUnread).show();
        } else {
            badge.text('').hide();
        }
    };

    var loadLocationNotifications = function() {

        $.ajax({
            url: 'https://'+document.location.hostname+'/api/v2/Notifications/FetchLocationNotifications.php',
            type: 'post',
            dataType: 'json',
            success: function(result) {

                var stat = result.status;
                $(".notifications-holder").empty();

                if (stat === 200) {

                    var notifications = result.notifications;
                    var countUnread = parseInt(result.countUnread, 10) || 0;

                    updateUnreadBadge(countUnread);

                    if (notifications.length > 0) {

                        $(".notifications-holder").show();
                        $(".no-notifications-display").hide();

                        moment.locale(window.clinicDefaultLang); // change moment js language

                        notifications.forEach((n) =>{
                            let notificationText = null;
                            if (window.clinicDefaultLang == 'fr' && n.locnoti_textFr != null){
                                notificationText = n.locnoti_textFr;
                            } else {
                                notificationText = n.locnoti_text;
                            }

                            if (!notificationText) {
                                return;
                            };
                            $(".notifications-holder").append(`
                            <div class="row notification-item">
                                ${n.locnoti_read == 0 ? 
                                    `<div class="col-auto align-self-center">
                                        <div style="background: #ff0000; width:10px; height: 10px; border-radius: 50%;"></div>
                                    </div>` 
                                : ''}
                                <div class="col">
                                    <a href="${n.locnoti_url}" class="notification-url" data-notid="${n.locnoti_id}">
                                        <span class="notificaiton-text" style="font-weight: 300; font-size: 13px;">${notificationText}</span>
                                        <span class="notification-time mt-8" style="font-style: italic; color: #222222;">${moment.utc(n.locnoti_created).fromNow()}</span>
                                    </a>
                                </div>
                                <div class="col-auto align-self-center text-center">
                                    <a href="javascript:;" class="notification-clear" data-notid="${n.locnoti_id}">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </div>
                            </div>`);

                        });

                    } else {

                        $(".header-unread-notifications").hide();
                        $(".no-notifications-display").show();
                        $(".notifications-holder").hide();

                    }

                } else {

                    $(".header-unread-notifications").hide();
                    $(".no-notifications-display").show();
                    $(".notifications-holder").hide();
                }
                

            },
            error: function(result) {

                $(".header-unread-notifications").hide();
                $(".no-notifications-display").show();
                $(".notifications-holder").hide();
            }
        });

    };

    if (document.location.hostname != "developers.ottooptics.io") {
        loadLocationNotifications();
    }

    ////////////////////////////
    // ** Private Methods  ** //
    ////////////////////////////

    var Plugin = {
        /**
         * Run plugin
         * @returns {KTHeader}
         */
        construct: function(options) {
            if (KTUtil.data(element).has('header')) {
                the = KTUtil.data(element).get('header');
            } else {
                // reset header
                Plugin.init(options);

                // build header
                Plugin.build();

                KTUtil.data(element).set('header', the);
            }

            return the;
        },

        /**
         * Handles subheader click toggle
         * @returns {KTHeader}
         */
        init: function(options) {
            the.events = [];

            // merge default and user defined options
            the.options = KTUtil.deepExtend({}, defaultOptions, options);
        },

        /**
         * Reset header
         * @returns {KTHeader}
         */
        build: function() {
            var lastScrollTop = 0;
            var eventTriggerState = true;
            var viewportHeight = KTUtil.getViewPort().height;
            var documentHeight = KTUtil.getDocumentHeight();

            if (the.options.minimize.mobile === false && the.options.minimize.desktop === false) {
                return;
            }

            window.addEventListener('scroll', function() {
                var offset = 0, on, off, st;

                if (KTUtil.isInResponsiveRange('desktop')) {
                    offset = the.options.offset.desktop;
                    on = the.options.minimize.desktop.on;
                    off = the.options.minimize.desktop.off;
                } else if (KTUtil.isInResponsiveRange('tablet-and-mobile')) {
                    offset = the.options.offset.mobile;
                    on = the.options.minimize.mobile.on;
                    off = the.options.minimize.mobile.off;
                }

                st = KTUtil.getScrollTop();

                if (
                    (KTUtil.isInResponsiveRange('tablet-and-mobile') && the.options.classic && the.options.classic.mobile) ||
                    (KTUtil.isInResponsiveRange('desktop') && the.options.classic && the.options.classic.desktop)
                ) {
                    if (st > offset) { // down scroll mode
                        KTUtil.addClass(body, on);
                        KTUtil.removeClass(body, off);

                        if (eventTriggerState) {
                            Plugin.eventTrigger('minimizeOn', the);
                            eventTriggerState = false;
                        }
                    } else { // back scroll mode
                        KTUtil.addClass(body, off);
                        KTUtil.removeClass(body, on);

                        if (eventTriggerState == false) {
                            Plugin.eventTrigger('minimizeOff', the);
                            eventTriggerState = true;
                        }
                    }
                } else {
                    if (st > offset && lastScrollTop < st) { // down scroll mode
                        KTUtil.addClass(body, on);
                        KTUtil.removeClass(body, off);

                        if (eventTriggerState) {
                            Plugin.eventTrigger('minimizeOn', the);
                            eventTriggerState = false;
                        }
                    } else { // back scroll mode
                        KTUtil.addClass(body, off);
                        KTUtil.removeClass(body, on);

                        if (eventTriggerState == false) {
                            Plugin.eventTrigger('minimizeOff', the);
                            eventTriggerState = true;
                        }
                    }

                    lastScrollTop = st;
                }
            });
        },

        /**
         * Trigger events
         */
        eventTrigger: function(name, args) {
            for (var i = 0; i < the.events.length; i++) {
                var event = the.events[i];
                if (event.name == name) {
                    if (event.one == true) {
                        if (event.fired == false) {
                            the.events[i].fired = true;
                            return event.handler.call(this, the, args);
                        }
                    } else {
                        return event.handler.call(this, the, args);
                    }
                }
            }
        },

        addEvent: function(name, handler, one) {
            the.events.push({
                name: name,
                handler: handler,
                one: one,
                fired: false
            });
        }
    };

    //////////////////////////
    // ** Public Methods ** //
    //////////////////////////

    /**
     * Set default options
     */

    the.setDefaults = function(options) {
        defaultOptions = options;
    };

    /**
     * Register event
     */
    the.on = function(name, handler) {
        return Plugin.addEvent(name, handler);
    };

    ///////////////////////////////
    // ** Plugin Construction ** //
    ///////////////////////////////

    // Run plugin
    Plugin.construct.apply(the, [options]);

    // Init done
    init = true;

    // Return plugin instance
    return the;
};

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTHeader;
}
